import {useNavigation} from '@react-navigation/native';
import React from 'react';
import {Linking} from 'react-native';

import {Header} from '../../../components/Interface/Headers/Header'
import {Titles} from '../../../components/Interface/Typographies/Titles';
import {Button as ButtonFooter} from '../../../components/Interface/Forms/Buttons/Button';

import {
  Container,
  Content,
  ButtonContainer,
  Button,
  ButtonText,
  Footer,
} from './styles';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { SafeAreaView } from 'react-native-safe-area-context';

export function AcceptCreditCardRegulament() {
  const navigation = useNavigation();

  async function confirmTerm() {
    await AsyncStorage.setItem('creditcard_term', '1');
    navigation.goBack();
  }

  return (
    <SafeAreaView edges={['bottom']} style={{flex: 1}}>
    <Container>
      <Header
        icon="chevron-left"
        action={() => navigation.navigate('Initial')}
      />
      <Content>
        <Titles
          title="Aceite os termos de uso do cartão de crédito"
          subtitle="Ao continuar, você confirma que leu e que concorda com os termos de uso do cartão de crédito."
        />
        <ButtonContainer>
          <Button
            activeOpacity={1}
            onPress={() =>
              Linking.openURL(
                'https://barataocombustiveis.com.br/termos-e-condicoes',
              )
            }>
            <ButtonText>Termos de uso do cartão de crédito</ButtonText>
          </Button>
        </ButtonContainer>
      </Content>
      <Footer>

          <ButtonFooter
            title="Aceitar os termos e continuar"
            enabled
            onPress={confirmTerm}
          />

      </Footer>
    </Container>
    </SafeAreaView>
  );
}
